import { createStore } from 'vuex'

import Global from './Global.js'
import Search from './Search.js'
import Work from './Work.js'
import FilterBar from './FilterBar.js'
import ResultOptions from './ResultOptions.js'
import Blog from './Blog.js'

const getStore = () => {
  return createStore({
    modules: {
      Global,
      Search,
      Work,
      FilterBar,
      ResultOptions,
      Blog
    }
  })
}

export default getStore
